import { z } from 'zod';
/**
 * A boolean that arrives as a query string.
 *
 * Deliberately **not** `z.coerce.boolean()`. That one is `Boolean(value)`, and
 * `Boolean('false')` is `true` — so a client asking for `activeOnly=false` was
 * told yes. The portal's "show merged and archived" switch did nothing at all
 * because of it: the request went out correctly, the server read it backwards,
 * and every tombstone stayed invisible.
 *
 * Accepts an actual boolean too, so the same schema works when a test calls it
 * with a parsed object rather than a query string.
 */
export const booleanQueryParam = z.union([z.boolean(), z.stringbool()]);
//# sourceMappingURL=query-params.js.map